import { useCallback, useMemo } from 'react';
import { toast, ToastOptions, ToastContent } from 'react-toastify';

type Toast = 'info' | 'success' | 'warning' | 'error' | 'default';

export const useToast = () => {
  const onShowToast = useCallback(
    (content: ToastContent, type?: Toast, options?: ToastOptions) => {
      toast(content, {
        type,
        ...options,
      });
    },
    [],
  );

  return useMemo(
    () => ({
      onShowToast,
    }),
    [onShowToast],
  );
};
